<template>
    <div class="container">
        <br />
        <br />
        <div class="row">
            <div class="col-12">
                <h1 class="h4 font-weight-bolder mb-1">Learner Activity</h1>
                <p class="text-secondary mb-0">A list of the scenarios you've attempted.</p>
                <hr />
                <br />
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div v-show="!loading && cases.length == 0">
                    <br>
                    <br>
                    <br>
                    <div class="d-flex justify-content-center mb-5">
                        <img src="/static/general/img/undraw_no_data.svg" height="180" class="mw-100" alt="" />
                    </div>
                    <p class="text-center">
                        You don't have any learner activity yet. Revisit this page once you've attempted some scenarios.
                    </p>
                </div>
            </div>
        </div>

        <div class="row" v-show="!loading && cases.length != 0">
            <div class="col-12">
                <base-table
                    :table-data="cases"
                    :config="tableConfig"
                    empty-message="You don't have any learner activity yet."
                    :rows-per-page="20"
                    v-on:download="downloadSummary($event)"
                ></base-table>
            </div>
        </div>
    </div>
</template>

<script>
import BaseTable from "@/components/BaseTable"
import http from "@/axios.js"
import Utilities from "@/assets/js/utilities.js"

export default {
    name: "LearnerHistory",
    components: {
        BaseTable,
    },
    data() {
        return {
            cases: [],
            tableConfig,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        isEmpty() {
            return !this.loading && this.cases.length == 0
        },
    },
    methods: {
        downloadSummary(session) {
            window.open(`/export/sessions/${session.id}/response-summary`, "_blank")
        },
    },
    created() {
        let vm = this
        vm.$store.dispatch("addLoad")
        http.get("/api/history/")
            .then(function (response) {
                vm.cases = response.data
            })
            .finally(() => {
                vm.$store.dispatch("removeLoad")
            })
    },
}

const tableConfig = {
    initialSort: "Started On",
    initialSortDescend: true,
    multiSelect: false,
    actions: true,
    customActions: [
        {
            name: "Download PDF",
            event: "download",
        },
    ],
    columns: [
        {
            name: "Scenario",
            sort: true,
            key: "case.public_title",
        },
        {
            name: "Complete",
            sort: true,
            key: "complete",
            display: (row) => {
                return row.complete ? "Yes" : "No"
            },
        },
        {
            name: "Successful",
            sort: true,
            key: "successful",
            display: (row) => {
                return row.successful ? "Yes" : "No"
            },
        },
        {
            name: "Score",
            sort: true,
            key: "score",
            display: (row) => {
                if (row.score && row.score_max) {
                    return row.score + " / " + row.score_max
                } else if (row.score !== null) {
                    return String(row.score)
                } else {
                    return "-"
                }
            },
        },
        {
            name: "Started On",
            sort: true,
            type: "date",
            sortKey: "start_time",
            display: (row) => {
                return Utilities.formatDateTime(row.start_time)
            },
        },
    ],
}
</script>
